export default function buildRoundPayload({
  ballot,
  resolvedBestSpeakerId,
  teams,
}) {
  return {
    details: {
      resolution: ballot.details.resolution,
      pro_team: teams.pro,
      con_team: teams.con,
      tournament: ballot.details.tournament,
      round_number: ballot.details.roundNumber,
    },
    notes: ballot.notes,
    pro_scores: ballot.proScores,
    con_scores: ballot.conScores,
    speakers: ballot.speakers,
    best_speaker_id: resolvedBestSpeakerId,
    custom_criteria: (ballot.customCriteria || [])
      .filter((criterion) => criterion.name.trim())
      .map((criterion) => ({
        ...criterion,
        name: criterion.name.trim(),
      })),
    timer_preset_name: ballot.timerPresetName || "PFJudgePro Standard",
  };
}